export const faqs = [
	{
		id: 1,
		questionId: 'ContactUsId15',
		answerId: 'ContactUsId16'
	},
	{
		id: 2,
		questionId: 'ContactUsId17',
		answerId: 'ContactUsId18'
	},
	{
		id: 3,
		questionId: 'ContactUsId19',
		answerId: 'ContactUsId20'
	},
	{
		id: 4,
		questionId: 'ContactUsId21',
		answerId: 'ContactUsId22'
	},
	{
		id: 5,
		questionId: 'ContactUsId23',
		answerId: 'ContactUsId24'
	},
	{
		id: 6,
		questionId: 'ContactUsId25',
		answerId: 'ContactUsId26'
	},
];
